import { DashboardWidget } from 'features/widget/types'
import { PatchedPostMetricResult } from 'schemas/PostMetricResultSchema'

// eslint-disable-next-line import/prefer-default-export
export const retrievePostMetrics = (widgetData: DashboardWidget<PatchedPostMetricResult>) =>
  widgetData.data?.[0].results?.[0].data.metrics
